export const CONTACT_SUPPORT: "SUPPORT/CONTACT_SUPPORT" = "SUPPORT/CONTACT_SUPPORT";
export const CONTACT_SUPPORT_SUCCESS: "SUPPORT/CONTACT_SUPPORT_SUCCESS" = "SUPPORT/CONTACT_SUPPORT_SUCCESS";
export const CONTACT_SUPPORT_FAIL: "SUPPORT/CONTACT_SUPPORT_FAIL" = "SUPPORT/CONTACT_SUPPORT_FAIL";
export const CONTACT_SUPPORT_CLEAR: "SUPPORT/CLEAR" = "SUPPORT/CLEAR";
export const CONTACT_SUPPORT_CLOSE_ERROR: "SUPPORT/CLOSE_ERROR" = "SUPPORT/CLOSE_ERROR";
